import { render, staticRenderFns } from "./Modulo.vue?vue&type=template&id=3ba55771&"
import script from "./Modulo.vue?vue&type=script&lang=js&"
export * from "./Modulo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports